"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IDPHint = exports.SwapContextBoundary = exports.LoginBoundary = exports.SSRBoundary = exports.hasScope = exports.hasAnyScope = exports.hasAllScopes = exports.AuthScopes = exports.createMockAuthProvider = exports.createAuthSwapProvider = exports.createAuthProvider = void 0;
// Providers
var auth_provider_1 = require("./providers/auth-provider");
Object.defineProperty(exports, "createAuthProvider", { enumerable: true, get: function () { return auth_provider_1.createAuthProvider; } });
Object.defineProperty(exports, "createAuthSwapProvider", { enumerable: true, get: function () { return auth_provider_1.createAuthSwapProvider; } });
var mock_auth_provider_1 = require("./providers/mock-auth-provider");
Object.defineProperty(exports, "createMockAuthProvider", { enumerable: true, get: function () { return mock_auth_provider_1.createMockAuthProvider; } });
__exportStar(require("./hooks/scopes"), exports);
// Helpers
var scopes_1 = require("./scopes");
Object.defineProperty(exports, "AuthScopes", { enumerable: true, get: function () { return scopes_1.AuthScopes; } });
Object.defineProperty(exports, "hasAllScopes", { enumerable: true, get: function () { return scopes_1.hasAllScopes; } });
Object.defineProperty(exports, "hasAnyScope", { enumerable: true, get: function () { return scopes_1.hasAnyScope; } });
Object.defineProperty(exports, "hasScope", { enumerable: true, get: function () { return scopes_1.hasScope; } });
// Boundaries
var ssr_boundary_1 = require("./boundaries/ssr-boundary");
Object.defineProperty(exports, "SSRBoundary", { enumerable: true, get: function () { return ssr_boundary_1.SSRBoundary; } });
var login_boundary_1 = require("./boundaries/login-boundary");
Object.defineProperty(exports, "LoginBoundary", { enumerable: true, get: function () { return login_boundary_1.LoginBoundary; } });
var swap_context_boundary_1 = require("./boundaries/swap-context-boundary");
Object.defineProperty(exports, "SwapContextBoundary", { enumerable: true, get: function () { return swap_context_boundary_1.SwapContextBoundary; } });
// Constants
var constants_1 = require("./constants");
Object.defineProperty(exports, "IDPHint", { enumerable: true, get: function () { return constants_1.IDPHint; } });
